import {useState,useEffect} from "react"
import { useParams,useNavigate } from "react-router-dom"
import SideBar from "../components/SideBar"
import{useSelector,useDispatch} from "react-redux"
import { editMovie, fetchDetailMovie, fetchGenre, fetchMovie } from "../store/actions"
import Swal from "sweetalert2"

export default function EditPage(){
    const{id}= useParams()
    const dispatch= useDispatch()
    const navigate= useNavigate()
    const{genres}= useSelector((state)=>state.genre)
    const {detailMovie}= useSelector((state)=> state.movie)

    const [editInput,setEdit]= useState({
        title:"",
        synopsis:"",
        trailerUrl: "",
        imgUrl:"",
        rating: "",
        genreId: ""
    })

useEffect(()=>{
   dispatch(fetchGenre())
},[])

    useEffect(()=>{
        dispatch(fetchDetailMovie(id))
    },[])

    useEffect(()=>{
        if(detailMovie.title){
            setEdit({
                title:detailMovie.title,
                synopsis:detailMovie.synopsis,
                trailerUrl: detailMovie.trailerUrl,
                imgUrl:detailMovie.imgUrl,
                rating: detailMovie.rating,
                genreId: detailMovie.genreId
            })
        }
    },[detailMovie])

    const inputEdit= (e)=>{
        const {name,value}= e.target
        setEdit({
            ...editInput,
            [name]: value
        })
    }

    const editHandler= (e)=>{
        e.preventDefault();
        dispatch(editMovie(id,editInput))
        .then((response)=>{
            return response.json()
        })
        .then((data)=>{
            if(data.message){
                navigate(`/edit/${id}`)
                Swal.fire({
                    icon: "error",
                    title: data.message
                })
            }else{
                Swal.fire({
                    icon: "success",
                    title: `Success edit id ${id}`
                })
                dispatch(fetchMovie())
                navigate('/')
            }
        })
        .catch((error)=>{
            console.log(error);
        })
    }


    return(
        <div>
        <SideBar/>
   <form onSubmit={editHandler}>
<div className="justify-center items-center flex flex-col" style={{height:"100vh"}}>
<div className="text-center rounded-lg pt-20" style={{width: "1000px", height: "800px"}}>
   <p className="font-bold" style={{fontSize: "15pt"}}>Edit Movie</p>
   <div className="pt-5">
   <label>Title</label><br/>
   <input value={editInput.title} name="title" onChange={inputEdit}  type="text" style={{width: "300px", height:"35px"}} placeholder="Title" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
    <label>Synopsis</label><br/>
   <input value={editInput.synopsis} name="synopsis" onChange={inputEdit} type="text" style={{width: "300px", height:"35px"}} placeholder="Synopsis"  className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Trailer Url</label><br/>
   <input value={editInput.trailerUrl} name="trailerUrl" onChange={inputEdit}  type="text" style={{width: "300px", height:"35px"}} placeholder="Trailer Url" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Image Url</label><br/>
   <input value={editInput.imgUrl} name="imgUrl" onChange={inputEdit}  type="text" style={{width: "300px", height:"35px"}} placeholder="Image Url" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Rating</label><br/>
   <input value={editInput.rating} name="rating" onChange={inputEdit}  type="number" style={{width: "300px", height:"35px"}} placeholder="Rating" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Genre</label><br/>
   <select value={editInput.genreId} name="genreId" onChange={inputEdit}>
        {genres.map((genre)=>
        <option key={genre.id} value={genre.id} onChange={inputEdit}>{genre.name}</option>
        )}
    </select>
   </div>
   <div className="pt-5 pb-10">
   <button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Submit</button>
   </div>
</div>
</div>
</form>
</div>
    )
}